import './MapContainer.scss';
export default function MapContainerComponent() {
    return (
        <section id='contact' className='map-container tw-px-4 md:tw-px-16 tw-pt-[45px] md:tw-pt-[90px]'>
            <h3 className="section-header tw-text-center tw-pb-8">
                Find Us Here
            </h3>
            <div className="tw-grid tw-grid-cols-12 tw-gap-4">
                <div className="tw-col-span-12 md:tw-col-span-2"></div>
                <div className="tw-col-span-12 md:tw-col-span-8">
                    <div className='tw-pb-16 tw-flex tw-justify-center '>
                        <p className='md:tw-w-1/2 text-center'>
                            Welcome to Kakariki! ☕✨ Find us on the map below and drop by for a cozy atmosphere, delicious coffee, and great company. We can't wait to see you!
                        </p>
                    </div>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2588.3121722070837!2d174.7758258756586!3d-41.28218854011237!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6d38af54020d061d%3A0x5f8c30400b0b2eb0!2sKakariki%20Coffee!5e1!3m2!1snl!2snl!4v1739726346811!5m2!1snl!2snl"

                        height="450"
                        className='map-iframe tw-rounded'
                        style={{ border: "0" }} allowfullscreen="" loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </div>


        </section>

    );
}